import { AppName } from './env-types';

/**
 * Get the HTTP port that the localhost server will listen on.
 * 
 * IMPORTANT: The mapping of ports to app names must be the
 * same as the mapping in func-common/env 
 */

export function getLocalPort(appName: AppName) {

	const ports: Record<AppName, number> = {
		'Admin': 5001,
		'Dashboards': 5002,
		'Devo': 5003,
		'Programs': 5004,
		'Public': 5005,
		'Staff': 5006,
		'Training': 5007,
	};

	return ports[appName];
}